/**
 * safely format initials
 * @param first
 * @param last
 * A helper method to cleanup initials to prevent non-string
 * i.e. ""[0] + ""[0] = NaN
 * because ""[0] is undefined but "".substring(0, 1) = ""
 */
const safelyFormatInitials = (first: string, last: string): string => {
  // @ts-ignore
  const safeFirst = typeof first === "string" ? first : "";
  // @ts-ignore
  const safeLast = typeof last === "string" ? last : "";
  return `${safeFirst.substring(0, 1)}${safeLast.substring(0, 1)}`;
};

export { safelyFormatInitials };
